<template>
    <div>
        <div class="echarts-container" :id="id" />
        <div id="tooltip" class="tooltip" :style="tooltipStyle" v-show="showTooltip">
            <i class="tooltip-close el-icon-close" @click="mouseInTooltip = false, mouseInPopover = false"></i>
            <table border="0">
                <tr class="th">
                    <td style="padding: 5px 15px;">{{ $t('confirmation.details_list.table.unique_id_nocss') }}</td>
                    <td style="padding: 5px 15px;">{{ $t('confirmation.details_list.table.confirmation_type') }}</td>
                    <td style="padding: 5px 15px;">{{ $t('confirmation.details_list.table.entity_name') }}</td>
                    <td style="padding: 5px 15px;">{{ $t('confirmation.details_list.table.addressee_entity_name') }}</td>
                    <td style="padding: 5px 15px;">{{ $t('confirmation.details_list.table.balance_sheet_date') }}</td>
                    <td style="padding: 5px 15px;">{{ tooltipIndexs.dataIndex === 0 ? $t('confirmation.details_list.table.number_of_days_since_received') :  $t('confirmation.details_list.table.days_of_pending_for_authorisation')}}</td>
                </tr>
                <tr
                    v-for="(v, k) in tableData[`${tooltipIndexs.dataIndex}_${tooltipIndexs.seriesIndex}`]"
                    class="tr"
                    :key="k">
                        <td style="padding: 5px 15px;">{{ v.uniqueId }}</td>
                        <td style="padding: 5px 15px;">{{ $t(`confirmation_type._${ v.isBank }`) }}</td>
                        <td style="padding: 5px 15px;">{{ v.confirmationEntityName }}</td>
                        <td style="padding: 5px 15px;">{{ v.addrEntityName }}</td>
                        <td style="padding: 5px 15px;">{{ v.balanceSheetDateStr }}</td>
                        <td style="padding: 5px 15px;">{{ tooltipIndexs.dataIndex === 0 ? v.daysOfReceivedAndProcessedByAddressees : v.daysOfPendingForAuthorisation }}</td>
                </tr>    
            </table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EchartsXBarTable from './EchartsXBarTable'
import * as echarts from 'echarts'
import { debounce, dateFormat } from '@/utils'


export default {
    name: 'EchartsXBar',
    components: { EchartsXBarTable },
    props: {
        renderData: {
            type: Object,
            default: () => {
                return {
                    userSetOverdueDays: [{ amount: 0 }, { amount: 0 }],
                    userProcessOverdueDays: [{ amount: 0 }, { amount: 0 }]
                }
            }
        },
        id: {
            type: String,
            default: 'xbar'
        },
        confirmation_bar4_input_1: {
            type: String,
            default: 5
        },
        confirmation_bar4_input_2: {
            type: String,
            default: 15
        },
    },
    watch: {
        renderData(val) {
            if (!val) return
            this.initChart()
        },
        getCollapse() {
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                if (this.echartsDom) this.echartsDom.resize()
            }, 350)
        }
    },
    computed: {
        ...mapGetters('common', {
            getCollapse: 'getCollapse'
        }),
        showTooltip() {
            return this.mouseInPopover || this.mouseInTooltip
        },
        tableData() {
            return {
                '1_1': this.renderData.userSetOverdueDays && this.renderData.userSetOverdueDays.find(v => v.confirmationType == '0') && this.renderData.userSetOverdueDays.find(v => v.confirmationType == '0').confirmationInfoList
                    ? this.renderData.userSetOverdueDays.find(v => v.confirmationType == '0').confirmationInfoList.map((v) => ({ isBank: 0, balanceSheetDateStr: this.dateFmt(v.balanceSheetDate), ...v }))
                    : [],
                '1_0': this.renderData.userSetOverdueDays && this.renderData.userSetOverdueDays.find(v => v.confirmationType == '1') && this.renderData.userSetOverdueDays.find(v => v.confirmationType == '1').confirmationInfoList
                    ? this.renderData.userSetOverdueDays.find(v => v.confirmationType == '1').confirmationInfoList.map((v) => ({ isBank: v.type, balanceSheetDateStr: this.dateFmt(v.balanceSheetDate), ...v }))
                    : [],
                '0_1': this.renderData.userProcessOverdueDays && this.renderData.userProcessOverdueDays.find(v => v.confirmationType == '0') && this.renderData.userProcessOverdueDays.find(v => v.confirmationType == '0').confirmationInfoList
                    ? this.renderData.userProcessOverdueDays.find(v => v.confirmationType == '0').confirmationInfoList.map((v) => ({ isBank: 0, balanceSheetDateStr: this.dateFmt(v.balanceSheetDate), ...v }))
                    : [],
                '0_0': this.renderData.userProcessOverdueDays && this.renderData.userProcessOverdueDays.find(v => v.confirmationType == '1') && this.renderData.userProcessOverdueDays.find(v => v.confirmationType == '1').confirmationInfoList
                    ? this.renderData.userProcessOverdueDays.find(v => v.confirmationType == '1').confirmationInfoList.map((v) => ({ isBank: v.type, balanceSheetDateStr: this.dateFmt(v.balanceSheetDate), ...v }))
                    : []
            }
        }
    },
    mounted() {
        if (!this.renderData) return
        this.initChart()
        this.__resizeHandler = debounce(() => {
            if (this.echartsDom) this.echartsDom.resize()
        }, 350)
        window.addEventListener('resize', this.__resizeHandler)
    },
    data() {
        return {
            echartsDom: null,
            selectedBlock: [],
            selectedName: [],
            placement: 'top',
            mousePosition: [0, 0],
            tooltipStyle: {top: '-1000px', left: '-1000px'},
            mouseInTooltip: false,
            mouseInPopover: false,
            tooltipIndexs: {
                dataIndex: 0,
                seriesIndex: 0
            },
            tooltipDisappearTimeout: null
        }
    },
    beforeDestroy() {
        if (!this.echartsDom) {
            return
        }
        clearTimeout(this.timer)
        window.removeEventListener('resize', this.__resizeHandler)
        this.echartsDom.dispose()
        this.echartsDom = null
    },
    methods: {
        dateFmt(date) {
             
            return dateFormat(new Date(date), 'yyyy-MM-dd')
        },
        initChart() {
             
            if (!document.getElementById(this.id)) return
            this.echartsDom = echarts.getInstanceByDom(document.getElementById(this.id))
             
            if (this.echartsDom == null) {
                this.echartsDom = echarts.init(document.getElementById(this.id), null, {renderer: 'svg'})
            }
            const option = {
                color: [
                '#00338d','#00b8f5'
                ],
                legend: {
                    show: true,
                    x: 'center',
                    y: 'bottom',
                    icon: 'squire',
                    itemWidth: 13,
                    itemHeight: 13,
                    // data: legends,
                    textStyle: {
                        fontSize: this.$i18n.locale === 'zh' ? 11 : 10,
                        lineHeight: this.$i18n.locale === 'zh' ? 11 : 10
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    minInterval: 1
                },
                yAxis: {
                    type: 'category',
                    data: ['', ''],
                    minInterval: 1
                },
                series: [
                    {
                        name: this.$t('confirmation_type._1_all'),
                        type: 'bar',
                        stack: 'total',
                        // emphasis: {
                        //   focus: 'self'
                        // },
                        data: [
                            {
                                value: this.renderData.userProcessOverdueDays && this.renderData.userProcessOverdueDays.find(v => v.confirmationType == '1') && this.renderData.userProcessOverdueDays.find(v => v.confirmationType == '1').amount ? this.renderData.userProcessOverdueDays.find(v => v.confirmationType == '1').amount : '',
                                name: '被函证方已签收_银行',
                                selected: false
                            },
                            {
                                value: this.renderData.userSetOverdueDays && this.renderData.userSetOverdueDays.find(v => v.confirmationType == '1') && this.renderData.userSetOverdueDays.find(v => v.confirmationType == '1').amount ? this.renderData.userSetOverdueDays.find(v => v.confirmationType == '1').amount : '',
                                name: '待被审计_银行',
                                selected: false
                            }
                        ],
                        barWidth: '30px',
                        label: {
                            show: true,
                            color: 'white',
                            fontFamily: 'KPMG',
                            fontWeight: 'bold',
                            fontSize: 12
                        },
                        selectedMode: 'single',
                        select: {
                            itemStyle: {
                                borderColor: '#000',
                                borderWidth: 4
                            }
                        },
                        selectedMap: {}
                    },
                    {
                        name: this.$t('confirmation_type._0'),
                        type: 'bar',
                        stack: 'total',
                        // emphasis: {
                        //   focus: 'self'
                        // },
                        data: [
                            {
                                value: this.renderData.userProcessOverdueDays && this.renderData.userProcessOverdueDays.find(v => v.confirmationType == '0') && this.renderData.userProcessOverdueDays.find(v => v.confirmationType == '0').amount ? this.renderData.userProcessOverdueDays.find(v => v.confirmationType == '0').amount : '',
                                selected: false,
                                name: '被函证方已签收_非银行'
                            },
                            {
                                value: this.renderData.userSetOverdueDays && this.renderData.userSetOverdueDays.find(v => v.confirmationType == '0') && this.renderData.userSetOverdueDays.find(v => v.confirmationType == '0').amount ? this.renderData.userSetOverdueDays.find(v => v.confirmationType == '0').amount : '',
                                selected: false,
                                name: '待被审计_非银行'
                            }
                        ],
                        barWidth: '30px',
                        label: {
                            show: true,
                            color: 'white',
                            fontFamily: 'KPMG',
                            fontWeight: 'bold',
                            fontSize: 12
                        },
                        selectedMode: 'single',
                        select: {
                            itemStyle: {
                                borderColor: '#000',
                                borderWidth: 2
                            }
                        },
                        selectedMap: {}
                    }
                ]
            }
            this.echartsDom.setOption(option, true)
            this.bindEvent()
        },
        bindEvent() {
            /**
             * 鼠标在整个body上移动，记录鼠标点位
             */
            const bodyMove = e => {
                //  
                this.mousePosition = [e.pageX, e.pageY]
            }
            document.removeEventListener('mousemove', bodyMove)
            document.body.addEventListener('mousemove', bodyMove)

            /**
             * 鼠标移入echarts，记录移入的哪个柱
             * 如果悬浮框没显示则按照鼠标当前位置显示出来
             */
            this.echartsDom.off('mouseover')
            this.echartsDom.on('mouseover', e => {

                // dataIndex == 0 是下面两个柱，dataIndex == 1 是上面两个柱
                this.tooltipIndexs.dataIndex = e.dataIndex
                this.tooltipIndexs.seriesIndex = e.seriesIndex
                if (this.showTooltip) return

                // if (this.tooltipDisappearTimeout) {
                //      
                //     clearTimeout(this.tooltipDisappearTimeout)
                // }
                this.mouseInTooltip = true

                let { left, top, width } = document.querySelector('.input-container').getBoundingClientRect()
                this.tooltipStyle = {top: `${top}px`, right: `calc(100% - ${left + width}px)`}
            })

            /**
             * 鼠标移出echats
             * 延迟一段时间记录移出状态
             */
            this.echartsDom.off('mouseout')
            this.echartsDom.on('mouseout', e => {
                this.tooltipDisappearTimeout = setTimeout(() => {
                    this.mouseInTooltip = false
                }, 0)
            })

            /**
             * 鼠标移出悬浮框
             */
            document.getElementById('tooltip').addEventListener('mouseleave', e => {
                // this.tooltipDisappearTimeout = setTimeout(() => {
                    // this.mouseInPopover = false
                // }, 500)
            })

            /**
             * 鼠标在悬浮框里
             */
            document.getElementById('tooltip').addEventListener('mousemove', e => {
                // if (this.tooltipDisappearTimeout) {
                //      
                //     clearTimeout(this.tooltipDisappearTimeout)
                // }
                this.mouseInPopover = true
            })

            /**
             * 鼠标点击echats
             */
            this.echartsDom.off('click')
            this.echartsDom.on('click', (e) => {

                const options = this.echartsDom.getOption()
                 

                window.__confirmationCleanSelec_xbar && window.__confirmationCleanSelec_xbar()
                options.series.forEach(v => {
                    if (v.name == e.seriesName) {
                        v.selectedMap[e.name] = true
                    } else {
                        v.selectedMap = {}
                        v.selectedMap[e.name] = false
                    }
                })
                 
                this.echartsDom.setOption(options, true)
                
                window.__confirmationCleanSelec_bar1 && window.__confirmationCleanSelec_bar1()
                window.__confirmationCleanSelec_bar2 && window.__confirmationCleanSelec_bar2()
                window.__confirmationCleanSelec_bar3 && window.__confirmationCleanSelec_bar3()
                window.__confirmationCleanSelec_pie && window.__confirmationCleanSelec_pie()
                
                let type = []
                let confirmation_bar4_input_1 = false
                let confirmation_bar4_input_2 = false
                options.series.forEach(v => {
                    if (v.selectedMap && v.selectedMap['待被审计_银行'] && v.selectedMap['待被审计_银行'] === true) {
                        confirmation_bar4_input_1 = this.confirmation_bar4_input_1 ? this.confirmation_bar4_input_1 - 0 : 5
                        type = ['1', '2']
                    }
                    if (v.selectedMap && v.selectedMap['待被审计_非银行'] && v.selectedMap['待被审计_非银行'] === true) {
                        confirmation_bar4_input_1 = this.confirmation_bar4_input_1 ? this.confirmation_bar4_input_1 - 0 : 5
                        type = ['0']
                    }
                    if (v.selectedMap && v.selectedMap['被函证方已签收_银行'] && v.selectedMap['被函证方已签收_银行'] === true) {
                        confirmation_bar4_input_2 = this.confirmation_bar4_input_2 ? this.confirmation_bar4_input_2 - 0 : 15 
                        type = ['1', '2']
                    }
                    if (v.selectedMap && v.selectedMap['被函证方已签收_非银行'] && v.selectedMap['被函证方已签收_非银行'] === true) {
                        confirmation_bar4_input_2 = this.confirmation_bar4_input_2 ? this.confirmation_bar4_input_2 - 0 : 15 
                        type = ['0']
                    }
                })

                if (type.length > 0) {
                    window.__listenDashboardChangeFilter && window.__listenDashboardChangeFilter({type, confirmation_bar4_input_1, confirmation_bar4_input_2})
                    this.$message.success(this.$t('confirmation_dashboard_filtered'))
                } else {
                    window.__listenDashboardChangeFilter && window.__listenDashboardChangeFilter({})
                    
                }
            })

            window.__confirmationCleanSelec_xbar = e => {
                const options = this.echartsDom.getOption()

                options.series.forEach((v, k) => {
                    v.selectedMap ? Object.keys(v.selectedMap).forEach(kk => {
                        if (v.selectedMap[kk]) {
                            v.selectedMap[kk] = false
                        }
                    }) : ''
                })

                this.echartsDom.setOption(options, true)
            }
        }
    }
}
</script>

<style scoped>
.echarts-container {
    width: 100%;
    height: 500px;
}
.tooltip {
    position: fixed;
    /* width: 50vw; */
    height: 250px;
    overflow-x: hidden;
    overflow-y: scroll;
    z-index: 9999999;
    background-color: white;
    -webkit-box-shadow: 0 0.041667rem 0.052083rem -0.026042rem rgba(0,0,0,.2), 0 0.083333rem 0.125rem 0.010417rem rgba(0,0,0,.14), 0 0.03125rem 0.15625rem 0.026042rem rgba(0,0,0,.12);
    box-shadow: 0 0.041667rem 0.052083rem -0.026042rem rgba(0,0,0,.2), 0 0.083333rem 0.125rem 0.010417rem rgba(0,0,0,.14), 0 0.03125rem 0.15625rem 0.026042rem rgba(0,0,0,.12);
    border-radius: 10px;
}
.tooltip table {
    padding-top: 20px;
}
.tooltip td {
    font-size: 12PX;
}
.tooltip .th td {
    font-weight: 600;
}
.tooltip-close {
    /* width: 50px; */
    /* height: 20px; */
    color: rgb(114, 118, 123);
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
    margin-top: 10px;
    margin-right: 10px;
    font-size: 14px;
}
</style>